import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './estilos/tokens.css';
import './estilos/base.css';

import App from './App.jsx';
import { ProveedorDeTema } from './nucleo/tema/ProveedorDeTema.jsx';
import { ProveedorDeSesion } from './nucleo/sesion/ProveedorDeSesion.jsx';
import { registrarSeccionesDelIncremento1 } from './nucleo/navegacion/seccionesDelIncremento1.js';
import { limpiarBorradoresVencidos } from './nucleo/borradores/almacenDeBorradores.js';
import { registrarServiceWorker } from './nucleo/pwa/actualizacionDelServiceWorker.js';

// Los modulos 2 a 5 se registran contra el contrato de navegacion sin tocar el
// shell (RF-019). En este incremento sus destinos existen como secciones vacias.
registrarSeccionesDelIncremento1();

// RN-145e: los borradores vencidos se limpian al arrancar la aplicacion, para que
// no se acumulen en el dispositivo. Es silencioso: no se avisa de borradores
// viejos (RN-145c).
limpiarBorradoresVencidos();

createRoot(document.getElementById('raiz')).render(
  <StrictMode>
    <ProveedorDeTema>
      <BrowserRouter>
        <ProveedorDeSesion>
          <App />
        </ProveedorDeSesion>
      </BrowserRouter>
    </ProveedorDeTema>
  </StrictMode>
);

// Service worker: cachea SOLO el armazon (D-02, RNF-020). Se registra despues del
// primer pintado para no competir con el arranque (RNF-007).
//
// El registro pasa por el gestor de actualizacion: una version nueva detectada NO
// se activa por debajo de una captura en curso, queda en espera y se avisa sin
// bloquear (RF-085, D-81, RN-130b, RN-131). Sin service worker la aplicacion sigue
// funcionando: solo no se instala.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => { registrarServiceWorker(); });
}
